import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { RolesService } from './role.servirce';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[accessRoles]'
})

export class HasRoleDirective implements OnInit {
    @Input() accessRoles: string;
    constructor(
        private viewContainerRef: ViewContainerRef,
        private templateRef: TemplateRef<any>,
        private rolesService: RolesService
    ) { }

    ngOnInit() {
        this.checkRole();
    }

    private checkRole() {
        this.rolesService.getRoles(this.accessRoles).then(data => {
            const userRoles = data;
            if (userRoles) {
                this.viewContainerRef.createEmbeddedView(this.templateRef);
            } else {
                this.viewContainerRef.clear();
            }
        });
    }
}
